import {useEffect} from 'react';
import {NEXT_PUBLIC_YM_COUNTER_NUMBER} from 'core/helpers/env';
import {useGetABTestQuery} from 'core/services/ABTestService';

let isInited = false;

export const useInitAbTest = (params: {abTestName: string}) => {
    const {abTestName} = params;
    const {data} = useGetABTestQuery({abTestName});

    useEffect(() => {
        if (data && !isInited) {
            if ('function' === typeof ym) {
                ym(NEXT_PUBLIC_YM_COUNTER_NUMBER, 'params', data);
                isInited = true;
            }
        }
    }, [data]);
};
